const keys = {
  all: ['monthly_earnings'],
}

export default keys
